
.textarea {
  width: 100%;
  color: var(--static-text-standard);
  background: var(--static-background-standard);
  border-radius: 8px;
  padding: 1ch;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--static-divider-standard);
  font: inherit;
}
.textarea:focus, input:hover {
  cursor: text;
  outline: none;
}
.textarea:disabled {
  cursor: not-allowed;
}
.textarea:not(.textarea:disabled):focus-within {
  border-color: var(--primary-enabled);
}

.noresize {
  resize: none;
}